import * as React from "react";
import styled from "styled-components";

const Section = styled.section`
  border-radius: 20px;
  border: 1px solid rgba(255, 101, 101, 1);
  background-color: var(--White, #fff);
  display: block;
  max-width: 1000px;
  width: 770px;
`;

const WarningContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 28px;
  width: 100%;
  padding: 0;
  overflow: hidden;

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 0;
  }
`;

const BackgroundImage = styled.img`
  display: block;
  width: 220px;
  min-width: 220px;
  height: auto;
  object-fit: cover;
  object-position: left center;

  @media (max-width: 991px) {
    width: 100%;
    min-width: 0;
    height: auto;
  }
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
  padding: 33px 20px 33px 0;

  @media (max-width: 991px) {
    padding: 20px;
  }
`;

const Title = styled.h5`
  color: var(--Red, #FF5050);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 108.333% */
  margin-bottom: 30px;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const WarningText = styled.p`
  color: var(--Black, #000);
  margin-top: 20px;
  width: 100%;
  font: 400 16px/20px Lato, sans-serif;
  overflow-wrap: anywhere;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const BoldText = styled.span`
  font-weight: 800;
`;

const CybercrimeWarningDesktop = () => {
    return (
        <Section>
            <WarningContainer>
                <BackgroundImage loading="lazy" src="./assets/cybercrime-warning-desktop.png" alt="" />
        <Content>
                    <Title>CYBERCRIME & WIRE FRAUD WARNING</Title>
                    <WarningText>
                        <BoldText>Email hacking and wire fraud, with the intent to misdirect wired funds, is a risk.</BoldText>
                        <br />
                        <br />
                        Emailing wire instructions, or relying upon wiring instructions that have been emailed, is dangerous as email is not secure and wire instructions could be intercepted and altered.
                        <br />
                        <br />
                        Always verify the accuracy of wiring instructions with the intended recipient, prior to sending funds, using a trusted and verified phone number for the recipient.
                        <br />
                        <br />
                        Be alert and suspicious of unexpected or last minute changes to wiring instructions, the appearance of misspelled words, and altered email addresses or domain names especially those that closely resemble a trusted email address or domain but are slightly different.
                    </WarningText>
                    </Content>
            </WarningContainer>
        </Section>
    );
}

export default CybercrimeWarningDesktop;